(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let sectionObserver;
  let pointerFrame;

  function buildAmbientParticles() {
    if (reducedMotion.matches || document.querySelector('.homepage-ambient')) return;
    const ambient = document.createElement('div');
    ambient.className = 'homepage-ambient';
    ambient.setAttribute('aria-hidden', 'true');

    for (let index = 0; index < 14; index += 1) {
      const particle = document.createElement('span');
      particle.className = 'homepage-ambient__particle';
      particle.style.setProperty('--particle-left', `${6 + ((index * 23) % 90)}%`);
      particle.style.setProperty('--particle-size', `${4 + (index % 5) * 2}px`);
      particle.style.setProperty('--particle-duration', `${15 + (index % 6) * 2.5}s`);
      particle.style.setProperty('--particle-delay', `${-index * 1.7}s`);
      particle.style.setProperty('--particle-drift', `${index % 2 === 0 ? 28 + index * 2 : -24 - index * 2}px`);
      ambient.appendChild(particle);
    }
    document.body.prepend(ambient);
  }

  function prepareSections() {
    const sections = [...document.querySelectorAll('#MainContent > .shopify-section')];
    if (!sections.length) return;
    sectionObserver?.disconnect();
    sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('home-motion-visible');
        sectionObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    sections.slice(1).forEach((section) => {
      section.classList.add('home-motion-section');
      section.querySelectorAll('.testi-card, product-card, .product-card, .collection-card, .editorial-collections__card, .editorial-spotlight__notes li, .editorial-products__card, .editorial-recipes__card, .editorial-story__steps li, .editorial-faq__item').forEach((item, index) => {
        item.style.setProperty('--motion-item-index', index % 6);
      });
      sectionObserver.observe(section);
    });
  }

  function prepareHeroParallax() {
    const hero = document.querySelector('.editorial-hero');
    if (!hero || hero.dataset.motionReady === 'true' || reducedMotion.matches) return;
    hero.dataset.motionReady = 'true';

    hero.addEventListener('pointermove', (event) => {
      if (event.pointerType === 'touch') return;
      cancelAnimationFrame(pointerFrame);
      pointerFrame = requestAnimationFrame(() => {
        const bounds = hero.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width - 0.5) * 2;
        const y = ((event.clientY - bounds.top) / bounds.height - 0.5) * 2;
        hero.style.setProperty('--home-pointer-x', x.toFixed(3));
        hero.style.setProperty('--home-pointer-y', y.toFixed(3));
      });
    });

    hero.addEventListener('pointerleave', () => {
      hero.style.setProperty('--home-pointer-x', '0');
      hero.style.setProperty('--home-pointer-y', '0');
    });
  }

  function initializeHomepageMotion() {
    document.body.classList.add('template-index-motion');
    buildAmbientParticles();
    prepareSections();
    prepareHeroParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHomepageMotion, { once: true });
  } else {
    initializeHomepageMotion();
  }

  document.addEventListener('shopify:section:load', () => {
    prepareSections();
    prepareHeroParallax();
  });
})();
